<template>
  <Details
    title="profile"
    resource="profiles"
    :base-path="basePath"
    data-provider="$raaDataProvider"
  >
    <template v-slot:side-panel>
      <DetailsSidePanel entity-title="profile" new-entity></DetailsSidePanel>
    </template>
    <template v-slot:default="detailsProps">
      <ProfileForm
        :on-submit="detailsProps.handleSubmit"
        :loading="detailsProps.loading"
        @close="detailsProps.redirectToList"
      />
    </template>
  </Details>
</template>

<script>
  import ModalNavigation from "@/mixins/ModalNavigation";
  import Details from "@/components/auth/details/Details";
  import DetailsSidePanel from "@/components/auth/details/DetailsSidePanel";
  import ProfileForm from "@/views/auth/raa-devtools/profiles/ProfileForm";

  export default {
    name: "ProfileCreate",
    components: {ProfileForm, Details, DetailsSidePanel},
    mixins: [ModalNavigation],
    computed: {
      basePath: function () {
        return this.$route.name.replace('create', 'index');
      }
    }
  }
</script>

<style scoped>

</style>
